const NEW_CROWD_CONTENT_ORDER_SET_MINIMUM_WORDS =
  "NEW_CROWD_CONTENT_ORDER_SET_MINIMUM_WORDS";
const NEW_CROWD_CONTENT_ORDER_SET_MAXIMUM_WORDS =
  "NEW_CROWD_CONTENT_ORDER_SET_MAXIMUM_WORDS";
const NEW_CROWD_CONTENT_ORDER_SET_WRITING_QUALITY =
  "NEW_CROWD_CONTENT_ORDER_SET_WRITING_QUALITY";
const NEW_CROWD_CONTENT_ORDER_SET_PROCESSING_TIME =
  "NEW_CROWD_CONTENT_ORDER_SET_PROCESSING_TIME";
const NEW_CROWD_CONTENT_ORDER_SET_COMPANY_SHORT_CODE =
  "NEW_CROWD_CONTENT_ORDER_SET_COMPANY_SHORT_CODE";
const NEW_CROWD_CONTENT_ORDER_SET_ORDER_PRIORITY =
  "NEW_CROWD_CONTENT_ORDER_SET_ORDER_PRIORITY";
const NEW_CROWD_CONTENT_ORDER_SET_CONTENT_TYPE =
  "NEW_CROWD_CONTENT_ORDER_SET_CONTENT_TYPE";
const NEW_CROWD_CONTENT_ORDER_SET_TEMPLATE_TYPE =
  "NEW_CROWD_CONTENT_ORDER_SET_TEMPLATE_TYPE";
const NEW_CROWD_CONTENT_ORDER_SET_ORDER_TITLE =
  "NEW_CROWD_CONTENT_ORDER_SET_ORDER_TITLE";
const NEW_CROWD_CONTENT_ORDER_SET_ORDER_INSTRUCTIONS =
  "NEW_CROWD_CONTENT_ORDER_SET_ORDER_INSTRUCTIONS";
const NEW_CROWD_CONTENT_ORDER_SET_ORDER_DESCRIPTION =
  "NEW_CROWD_CONTENT_ORDER_SET_ORDER_DESCRIPTION";
const NEW_CROWD_CONTENT_ORDER_SET_SPECIAL_NOTES =
  "NEW_CROWD_CONTENT_ORDER_SET_SPECIAL_NOTES";
const NEW_CROWD_CONTENT_ORDER_SET_TARGETED_PLACE =
  "NEW_CROWD_CONTENT_ORDER_SET_TARGETED_PLACE";
const NEW_CROWD_CONTENT_ORDER_SET_TARGETED_KEYWORDS =
  "NEW_CROWD_CONTENT_ORDER_SET_TARGETED_KEYWORDS";
const NEW_CROWD_CONTENT_ORDER_SET_FILE_UPLOADS =
  "NEW_CROWD_CONTENT_ORDER_SET_FILE_UPLOADS";
const NEW_CROWD_CONTENT_ORDER_SET_FORM_VALIDITY =
  "NEW_CROWD_CONTENT_ORDER_SET_FORM_VALIDITY";
const NEW_CROWD_CONTENT_ORDER_SET_CURRENT_VIEW =
  "NEW_CROWD_CONTENT_ORDER_SET_CURRENT_VIEW";
const NEW_CROWD_CONTENT_ORDER_RESET_FILE_UPLOADS =
  "NEW_CROWD_CONTENT_ORDER_RESET_FILE_UPLOADS";

const NEW_CROWD_CONTENT_ORDER_BEGIN_SENDING =
  "NEW_CROWD_CONTENT_ORDER_BEGIN_SENDING";
const NEW_CROWD_CONTENT_ORDER_BEGIN_UPDATING_KEYWORDS =
  "NEW_CROWD_CONTENT_ORDER_BEGIN_UPDATING_KEYWORDS";
const NEW_CROWD_CONTENT_ORDER_FINISH_SENDING =
  "NEW_CROWD_CONTENT_ORDER_FINISH_SENDING";
const NEW_CROWD_CONTENT_ORDER_FINISHED_SENDING_SUCCESS =
  "NEW_CROWD_CONTENT_ORDER_FINISHED_SENDING_SUCCESS";
const NEW_CROWD_CONTENT_ORDER_FINISHED_SENDING_FAILURE =
  "NEW_CROWD_CONTENT_ORDER_FINISHED_SENDING_FAILURE";

const NEW_CROWD_CONTENT_ORDER_RESET_FORM = "NEW_CROWD_CONTENT_ORDER_RESET_FORM";
const NEW_CROWD_CONTENT_ORDER_RETRY_SENDING =
  "NEW_CROWD_CONTENT_ORDER_RETRY_SENDING";
const NEW_CROWD_CONTENT_ORDER_RESET_KEYWORDS =
  "NEW_CROWD_CONTENT_ORDER_RESET_KEYWORDS";

export default {
  NEW_CROWD_CONTENT_ORDER_SET_CURRENT_VIEW,
  NEW_CROWD_CONTENT_ORDER_SET_MINIMUM_WORDS,
  NEW_CROWD_CONTENT_ORDER_SET_MAXIMUM_WORDS,
  NEW_CROWD_CONTENT_ORDER_SET_WRITING_QUALITY,
  NEW_CROWD_CONTENT_ORDER_SET_PROCESSING_TIME,
  NEW_CROWD_CONTENT_ORDER_SET_COMPANY_SHORT_CODE,
  NEW_CROWD_CONTENT_ORDER_SET_ORDER_PRIORITY,
  NEW_CROWD_CONTENT_ORDER_SET_CONTENT_TYPE,
  NEW_CROWD_CONTENT_ORDER_SET_TEMPLATE_TYPE,
  NEW_CROWD_CONTENT_ORDER_SET_ORDER_TITLE,
  NEW_CROWD_CONTENT_ORDER_SET_ORDER_INSTRUCTIONS,
  NEW_CROWD_CONTENT_ORDER_SET_ORDER_DESCRIPTION,
  NEW_CROWD_CONTENT_ORDER_SET_SPECIAL_NOTES,
  NEW_CROWD_CONTENT_ORDER_SET_TARGETED_PLACE,
  NEW_CROWD_CONTENT_ORDER_SET_TARGETED_KEYWORDS,
  NEW_CROWD_CONTENT_ORDER_SET_FILE_UPLOADS,
  NEW_CROWD_CONTENT_ORDER_SET_FORM_VALIDITY,
  NEW_CROWD_CONTENT_ORDER_RESET_FILE_UPLOADS,
  NEW_CROWD_CONTENT_ORDER_BEGIN_SENDING,
  NEW_CROWD_CONTENT_ORDER_BEGIN_UPDATING_KEYWORDS,
  NEW_CROWD_CONTENT_ORDER_FINISH_SENDING,
  NEW_CROWD_CONTENT_ORDER_FINISHED_SENDING_SUCCESS,
  NEW_CROWD_CONTENT_ORDER_FINISHED_SENDING_FAILURE,
  NEW_CROWD_CONTENT_ORDER_RESET_FORM,
  NEW_CROWD_CONTENT_ORDER_RETRY_SENDING,
  NEW_CROWD_CONTENT_ORDER_RESET_KEYWORDS,
};
